import * as React from "react";
const SvgChartBar = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 14, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15,56v-24 M32,56v-48 M49,56v-32" }));
export default SvgChartBar;
